import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

function Spinner({
  spinnerClassName = '',
  containerClassName = '',
  spinnerStyle = null,
  containerPosition,
  spinnerPosition,
}) {
  const spinnerElementClasses = classNames('ws-spinner__element', spinnerClassName, {
    'ws-spinner__element--centered': spinnerPosition === 'center',
  });
  const spinnerContainerClasses = classNames('ws-spinner', containerClassName, {
    'ws-spinner--bottom': containerPosition === 'bottom',
    'ws-spinner--center': containerPosition === 'center',
  });

  return (
    <div className={spinnerContainerClasses}>
      <div className={spinnerElementClasses} style={spinnerStyle}>
        <div className="ws-spinner__item" />
      </div>
    </div>
  );
}

Spinner.propTypes = {
  spinnerStyle: PropTypes.shape(),
  containerPosition: PropTypes.oneOf(['center', 'bottom']).isRequired,
  spinnerPosition: PropTypes.oneOf(['center', 'left']).isRequired,
  spinnerClassName: PropTypes.string,
  containerClassName: PropTypes.string,
};

export default Spinner;
